/* import __COLOCATED_TEMPLATE__ from './conversation-status-changed.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();